import logo from "../assets/logo.png";
import { Lang, t } from "../i18n/translations";

interface Props { lang: Lang; }

export default function Hero({ lang }: Props) {
  const tr = t[lang].hero;

  return (
    <section className="hero">
      <img src={logo} alt="MyLittleMouse" className="hero-logo" />
      <span className="hero-badge">{tr.badge}</span>
      <h1 className="hero-headline">
        {tr.headline.split("\n").map((line, i) => (
          <span key={i}>{line}<br /></span>
        ))}
      </h1>
      <p className="hero-sub">{tr.sub}</p>
      <div className="hero-ctas">
        <a className="btn btn-primary btn-lg" href="https://chromewebstore.google.com/detail/mylittlemouse/jcnbmdeefpiiennndfooadajlloochcp?hl=pt-BR&utm_source=ext_sidebar" target="_blank" rel="noreferrer" id="chrome">{tr.cta}</a>
        <a className="btn btn-outline btn-lg" href="https://github.com/leocoelh00/MyLittleMouse-releases/releases/latest" target="_blank" rel="noreferrer" id="download">{tr.ctaHelper}</a>
      </div>
      <p className="hero-note">{tr.note}</p>
    </section>
  );
}
